export const RUN_CODE_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const RUN_CODE_ERROR_MESSAGE =
  "Error in compiling code, please try again";
